import {createGlobalStyle, css} from "styled-components";

export const theme = {
  colors: {
    darkPrimary: "#174470",
    mediumPrimary: "#296FB4",
    lightPrimary: "#5093CE",
    darkSecondary: "#D07C31",
    mediumSecondary: "#ED9543",
    alert: "#be3f34",
    validate: "#4da13d",
    grey: "#383939",
    PlaceholderColor: "##97A0A8B3",
    shadowBloc: "#17447059",
    shadow: "#00000040",
    white: "#FFFFFF",
  },
};

export const breakpoints = {
  sm: "480px",
  md: "768px",
  lg: "992px",
  xl: "1200px",
  xxl: "1440px",
};

export const quicksandLight = css`
  font-family: "Quicksand", sans-serif;
  font-weight: 300;
  font-style: normal;
`;

export const quicksandRegular = css`
  font-family: "Quicksand", sans-serif;
  font-weight: 400;
  font-style: normal;
`;

export const quicksandMedium = css`
  font-family: "Quicksand", sans-serif;
  font-weight: 500;
  font-style: normal;
`;

export const quicksandSemiBold = css`
  font-family: "Quicksand", sans-serif;
  font-weight: 600;
  font-style: normal;
`;

export const quicksandBold = css`
  font-family: "Quicksand", sans-serif;
  font-weight: 700;
  font-style: normal;
`;

export const shadowButton = css`
  box-shadow: 1px 2px 4px 0 ${({theme}) => theme.colors.shadow};
`;

export const GlobalStyle = createGlobalStyle`
  html{
    font-size: 16px;
    transition: all 0.1s ease-in-out;
    @media (max-width: ${breakpoints.md}) {
    font-size: 14px;
}
  }
  body {
    position: relative;
    font-family: 'Quicksand', sans-serif;
    margin:0;
    min-width: 320px;
    
  }
  a{
    text-decoration: none;
    &:hover{
      cursor: pointer;
    }
  }
  p{
    margin:0;
  }
  button:hover{cursor:pointer}
  h1{
    ${quicksandBold}
    color:${({theme}) => theme.colors.darkPrimary}
  }
`;
